"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Modal_1 = __importDefault(require("./Modal"));
var styles_1 = require("../../styles");
var BsCheckCircle_1 = require("@react-icons/all-files/bs/BsCheckCircle");
function SuccessTxModal(_a) {
    var open = _a.open, onClose = _a.onClose;
    return ((0, jsx_runtime_1.jsx)(StyledModal, __assign({ disableBackdropClick: true, open: open, onClose: onClose }, { children: (0, jsx_runtime_1.jsxs)(StyledContainer, { children: [(0, jsx_runtime_1.jsx)(BsCheckCircle_1.BsCheckCircle, { className: "twap-success-modal-icon" }), (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ gap: 5, style: { alignItems: "center" } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { children: "Transaction #0842" }), (0, jsx_runtime_1.jsx)(material_1.Typography, { children: "created successfully" })] })), (0, jsx_runtime_1.jsx)(StyledClose, __assign({ onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: "Close" }) }))] }) })));
}
var StyledContainer = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    alignItems: "center",
    gap: 20,
});
var StyledClose = (0, material_1.styled)("button")({
    background: "unset",
    border: "unset",
    fontSize: 14,
    color: "inherit",
    cursor: "pointer",
});
var StyledModal = (0, material_1.styled)(Modal_1.default)({
    ".twap-modal-content": {
        width: "auto",
        padding: 30,
        ".twap-ui-close": {
            display: "none",
        },
    },
    ".twap-success-modal-icon": {
        width: 40,
        height: 40,
    },
});
exports.default = SuccessTxModal;
